import React from 'react'

import Accordion from '@cinch/oxd-components/accordion/src'
import RichText from '@cinch/oxd-components/rich-text/src'
import List, { ListItem } from '@cinch/oxd-components/list/src'
import { Tick } from '@cinch/oxd-components/icons/src'
import { Text, TextStyles } from '@cinch-labs/design-system'
import Link from '@cinch/oxd-components/link/src'

import { Pages, ValuationResponse, VehicleInformation } from '../../types'

import * as styles from './assumptions-panel.module.css'

interface Props {
  vehicleInformation: VehicleInformation
  valuation: ValuationResponse
}

const AssumptionsPanel: React.FC<Props> = ({ vehicleInformation, valuation }) => {
  const state = { vehicleInformation, valuation }
  const customStyles = {
    container: styles.container,
    wrapper: styles.wrapper,
    button: styles.button,
    label: styles.label,
  }

  return (
    <Accordion customStyles={customStyles} label={"Assumptions we've made about your vehicle"} isNested={true}>
      <div className={styles.assumptions} data-testid={'assumptions-panel'}>
        <RichText>
          <List>
            {valuation.assumptions.map((assumption) => (
              <ListItem key={assumption.parameterId} bulletIcon={Tick}>
                {assumption.assumptionText}
              </ListItem>
            ))}
          </List>
          <Text oxford={true} type={TextStyles.body2}>
            {'To see a full list of our assumptions or to make any changes or enter damage, please '}
            <Link oxford={true} to={Pages.SellValuationUpdate} state={state}>
              {'edit car details.'}
            </Link>
          </Text>
        </RichText>
      </div>
    </Accordion>
  )
}

export default AssumptionsPanel
